import {
  GetAuditLogLevelTranslationKey,
  GetStateForAuditLogLevel,
} from "akademika/akamont/utils/AuditLogLevelUtil";
import { Routes } from "../../constants/Routes";
import { FilterController } from "../sharedControllers/FilterController";

/**
 * @namespace akademika.akamont.pages.logList
 */

export default class LogList extends FilterController {
  route = Routes.LOG_LIST;
  parentRoute = Routes.DASHBOARD;

  onInit() {
    super.onInit();
    const defaultFilter = {};
    this.initFilters(defaultFilter, "api/AuditLog/GetAuditLogList");
  }

  public async onRouteMatched() {
    const sevenDaysAgo = new Date(Date.now() - 7 * 24 * 60 * 60 * 1000);
    this.getModel("filters").setProperty("/timestampFrom", sevenDaysAgo)

    await this.fetchModel(
      "api/AuditLog/GetAuditLogFilterOptions",
      "filterOptions"
    );
  }

  public async onLogDetails(auditLogId: string) {
    this.navTo(Routes.LOG_DETAILS, { auditLogId: auditLogId });
  }

  public getAuditLogLevelTranslation(logLevel: number) {
    const key = GetAuditLogLevelTranslationKey(logLevel);
    return this.translate(key);
  }

  public getStateForAuditLogLevel = GetStateForAuditLogLevel;
}
